"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FloatingPrimaryButtonLinkWithSpinnner = exports.ContrastButtonLinkWithSpinner = exports.GhostButtonLinkWithSpinner = exports.FlatButtonLinkWithSpinner = exports.QuaternaryButtonLinkWithSpinner = exports.TertiaryButtonLinkWithSpinner = exports.SecondaryButtonLinkWithSpinner = exports.PrimaryButtonLinkWithSpinner = exports.StyledButtonLinkFlat = exports.StyledButtonLinkSecondary = exports.StyledButtonLinkPrimary = exports.ContrastButtonLinkWithIcon = exports.GhostButtonLinkWithIcon = exports.FloatingPrimaryLinkWithIcon = exports.FlatButtonLinkWithIcon = exports.QuaternaryButtonLinkWithIcon = exports.TertiaryButtonLinkWithIcon = exports.SecondaryButtonLinkWithIcon = exports.PrimaryButtonLinkWithIcon = exports.IconButtonContent = exports.ContrastButtonWithIcon = exports.GhostButtonWithIcon = exports.FloatingPrimaryButtonWithIcon = exports.FlatButtonWithIcon = exports.QuaternaryButtonWithIcon = exports.TertiaryButtonWithIcon = exports.SecondaryButtonWithIcon = exports.PrimaryButtonWithIcon = exports.SpinningButtonContent = exports.FloatingPrimaryButtonWithSpinner = exports.FlatButtonWithSpinner = exports.ContrastButtonWithSpinner = exports.GhostButtonWithSpinner = exports.QuaternaryButtonWithSpinner = exports.TertiaryButtonWithSpinner = exports.SecondaryButtonWithSpinner = exports.PrimaryButtonWithSpinner = exports.workingSpinnerStyles = exports.workingButtonStyles = exports.activeIconStyles = exports.activeButtonStyles = exports.withIconStyles = exports.StyledButtonFlat = exports.StyledButtonQuaternary = exports.StyledButtonTertiary = exports.StyledButtonSecondary = exports.StyledButtonPrimaryFloating = exports.StyledButtonContrast = exports.StyledButtonGhost = exports.StyledButtonPrimary = void 0;
const react_1 = __importDefault(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
/******************
 * standard buttons
 ******************/
const BaseStyledButton = (0, styled_1.default)('button') `
  border-style: ${(0, ui_theme_1.fromTheme)('border_style')};
  border-width: ${(0, ui_theme_1.fromTheme)('border_width')};
  border-radius: ${(0, ui_theme_1.fromTheme)('border_radius')};
  cursor: pointer;
  display: inline-block;
  font-family: ${(0, ui_theme_1.fromTheme)('font_face')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight')};
  padding: ${(0, ui_theme_1.fromTheme)('spacing_small')} ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  text-decoration: none;
  transition: 0.3s;
  &:focus {
    outline: none;
  }
  &:disabled {
    cursor: not-allowed;
  }
`;
exports.StyledButtonPrimary = (0, styled_1.default)(BaseStyledButton) `
  background-color: ${(0, ui_theme_1.fromTheme)('color_button')};
  border-color: ${(0, ui_theme_1.fromTheme)('color_button')};
  color: ${(0, ui_theme_1.fromTheme)('color_text_contrast')};
  &:focus {
    outline-color: ${(0, ui_theme_1.fromTheme)('color_button')};
    outline-width: ${(0, ui_theme_1.fromTheme)('border_width')};
    outline-style: ${(0, ui_theme_1.fromTheme)('border_style')};
    outline-offset: ${(0, ui_theme_1.fromTheme)('border_width')};
  }
  &:hover {
    border-color: ${(0, ui_theme_1.fromTheme)('color_button_hover')};
    background-color: ${(0, ui_theme_1.fromTheme)('color_button_hover')};
  }
  &:disabled {
    cursor: not-allowed;
    background-color: ${(0, ui_theme_1.fromTheme)('color_button_disabled')};
    border-color: ${(0, ui_theme_1.fromTheme)('color_button_disabled')};
    color: ${(0, ui_theme_1.fromTheme)('color_text_button_disabled')};
  }
  &:active:not(:disabled) {
    outline-color: ${(0, ui_theme_1.fromTheme)('color_button')};
    outline-width: ${(0, ui_theme_1.fromTheme)('border_width')};
    outline-style: ${(0, ui_theme_1.fromTheme)('border_style')};
    outline-offset: ${(0, ui_theme_1.fromTheme)('border_width')};
    background-color: ${(0, ui_theme_1.fromTheme)('color_button_active')};
    border-color: ${(0, ui_theme_1.fromTheme)('color_button_active')};
    color: ${(0, ui_theme_1.fromTheme)('color_text_contrast')};
  }
`;
exports.StyledButtonGhost = (0, styled_1.default)(BaseStyledButton) `
  background-color: ${(0, ui_theme_1.fromTheme)('color_background')};
  border-color: ${(0, ui_theme_1.fromTheme)('color_button_contrast')};
  color: ${(0, ui_theme_1.fromTheme)('color_button_contrast_text')};

  &:focus {
    background-color: ${(0, ui_theme_1.fromTheme)('color_background')};
    outline-color: ${(0, ui_theme_1.fromTheme)('color_button_contrast')};
    outline-width: ${(0, ui_theme_1.fromTheme)('border_width')};
    outline-style: ${(0, ui_theme_1.fromTheme)('border_style')};
    outline-offset: 0;
  }

  &:hover {
    background-color: ${(0, ui_theme_1.fromTheme)('color_button_contrast_hover')};
    border-color: ${(0, ui_theme_1.fromTheme)('color_button_contrast_hover')};
    color: ${(0, ui_theme_1.fromTheme)('color_button_contrast_hover_text')};
  }

  &:active:not(:disabled) {
    background-color: ${(0, ui_theme_1.fromTheme)('color_button_contrast_hover')};
    border-color: ${(0, ui_theme_1.fromTheme)('color_button_contrast_hover')};
    color: ${(0, ui_theme_1.fromTheme)('color_button_contrast_hover_text')};

    outline-color: ${(0, ui_theme_1.fromTheme)('color_button')};
    outline-width: ${(0, ui_theme_1.fromTheme)('border_width')};
    outline-style: ${(0, ui_theme_1.fromTheme)('border_style')};
    outline-offset: ${(0, ui_theme_1.fromTheme)('border_width')};
  }

  &:disabled {
    background-color: ${(0, ui_theme_1.fromTheme)('color_button_disabled')};
    border-color: ${(0, ui_theme_1.fromTheme)('color_border_disabled')};
    color: ${(0, ui_theme_1.fromTheme)('color_text_button_disabled')};
    cursor: not-allowed;
  }
`;
exports.StyledButtonContrast = (0, styled_1.default)(BaseStyledButton) `
  background-color: ${(0, ui_theme_1.fromTheme)('color_background')};
  border-color: ${(0, ui_theme_1.fromTheme)('color_button_contrast')};
  color: ${(0, ui_theme_1.fromTheme)('color_button_contrast_text')};
  border: 2px ${(0, ui_theme_1.fromTheme)('border_style')} ${(0, ui_theme_1.fromTheme)('color_background')};
  position: relative;
  z-index: 1;

  &:after {
    content: '';
    display: block;
    position: absolute;
    z-index: -1;
    top: ${(0, ui_theme_1.fromTheme)('border_width')};
    left: ${(0, ui_theme_1.fromTheme)('border_width')};
    right: ${(0, ui_theme_1.fromTheme)('border_width')};
    bottom: ${(0, ui_theme_1.fromTheme)('border_width')};
    border: ${(0, ui_theme_1.fromTheme)('border_width')} ${(0, ui_theme_1.fromTheme)('border_style')}
      ${(0, ui_theme_1.fromTheme)('color_button_contrast')};
    border-radius: ${(0, ui_theme_1.fromTheme)('border_radius')};
  }

  &:focus,
  &:hover {
    background-color: ${(0, ui_theme_1.fromTheme)('color_button_contrast_hover')};
    border-color: ${(0, ui_theme_1.fromTheme)('color_button_contrast_hover')};
    color: ${(0, ui_theme_1.fromTheme)('color_button_contrast_hover_text')};
    text-decoration: none;

    &:after {
      background-color: ${(0, ui_theme_1.fromTheme)('color_button_contrast_hover')};
      border-color: ${(0, ui_theme_1.fromTheme)('color_button_contrast_hover_text')};
      color: ${(0, ui_theme_1.fromTheme)('color_button_contrast_hover')};
    }
  }

  &:disabled {
    background-color: ${(0, ui_theme_1.fromTheme)('color_button_disabled')};
    border-color: ${(0, ui_theme_1.fromTheme)('color_border_disabled')};
    color: ${(0, ui_theme_1.fromTheme)('color_text_button_disabled')};
    cursor: not-allowed;

    &:after {
      background-color: ${(0, ui_theme_1.fromTheme)('color_button_disabled')};
      border-color: ${(0, ui_theme_1.fromTheme)('color_button_disabled')};
      color: ${(0, ui_theme_1.fromTheme)('color_text_button_disabled')};
    }
  }
`;
exports.StyledButtonPrimaryFloating = (0, styled_1.default)(exports.StyledButtonPrimary) `
  padding-top: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  padding-bottom: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  border-radius: ${(0, ui_theme_1.fromTheme)('border_radius_floating_button')};
  box-shadow: ${(0, ui_theme_1.fromTheme)('box_shadow_floating_button')};
`;
exports.StyledButtonSecondary = (0, styled_1.default)(BaseStyledButton) `
  background-color: ${(0, ui_theme_1.fromTheme)('color_button_secondary')};
  border-color: ${(0, ui_theme_1.fromTheme)('color_border')};
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
  &:focus {
    background-color: ${(0, ui_theme_1.fromTheme)('color_background')};
    border-color: ${(0, ui_theme_1.fromTheme)('color_border_emphasis')};
    outline-color: ${(0, ui_theme_1.fromTheme)('color_border_emphasis')};
    outline-width: ${(0, ui_theme_1.fromTheme)('border_width')};
    outline-style: ${(0, ui_theme_1.fromTheme)('border_style')};
    outline-offset: 0;
  }
  &:hover {
    background-color: ${(0, ui_theme_1.fromTheme)('color_button_active')};
    color: ${(0, ui_theme_1.fromTheme)('color_text_contrast')};
  }
  &:active:not(:disabled) {
    outline-color: ${(0, ui_theme_1.fromTheme)('color_button_active')};
    outline-width: ${(0, ui_theme_1.fromTheme)('border_width')};
    outline-style: ${(0, ui_theme_1.fromTheme)('border_style')};
    outline-offset: ${(0, ui_theme_1.fromTheme)('border_width')};
    background-color: ${(0, ui_theme_1.fromTheme)('color_button_active')};
    border-color: ${(0, ui_theme_1.fromTheme)('color_button_active')};
    color: ${(0, ui_theme_1.fromTheme)('color_text_contrast')};
  }
  &:disabled {
    cursor: not-allowed;
    background-color: ${(0, ui_theme_1.fromTheme)('color_button_secondary_disabled')};
    color: ${(0, ui_theme_1.fromTheme)('color_text_button_disabled')};
    border-color: ${(0, ui_theme_1.fromTheme)('color_border_disabled')};
  }
`;
exports.StyledButtonTertiary = (0, styled_1.default)(exports.StyledButtonPrimary) `
  && {
    background-color: ${(0, ui_theme_1.fromTheme)('color_button_tertiary')};
    border-color: ${(0, ui_theme_1.fromTheme)('color_button_tertiary')};
    &:hover,
    &:focus {
      background-color: ${(0, ui_theme_1.fromTheme)('color_button_tertiary_hover')};
      border-color: ${(0, ui_theme_1.fromTheme)('color_button_tertiary_hover')};
    }
    &:disabled {
      background-color: ${(0, ui_theme_1.fromTheme)('color_button_tertiary_disabled')};
      border-color: ${(0, ui_theme_1.fromTheme)('color_button_tertiary_disabled')};
      color: ${(0, ui_theme_1.fromTheme)('color_text_button_disabled')};
      cursor: not-allowed;
    }
  }
`;
exports.StyledButtonQuaternary = (0, styled_1.default)(exports.StyledButtonPrimary) `
  && {
    background-color: ${(0, ui_theme_1.fromTheme)('color_button_quaternary')};
    border-color: ${(0, ui_theme_1.fromTheme)('color_button_quaternary')};
    &:hover,
    &:focus {
      background-color: ${(0, ui_theme_1.fromTheme)('color_button_quaternary_hover')};
      border-color: ${(0, ui_theme_1.fromTheme)('color_button_quaternary_hover')};
    }
    &:disabled {
      background-color: ${(0, ui_theme_1.fromTheme)('color_button_quaternary_disabled')};
      border-color: ${(0, ui_theme_1.fromTheme)('color_button_quaternary_disabled')};
      color: ${(0, ui_theme_1.fromTheme)('color_text_button_disabled')};
      cursor: not-allowed;
    }
  }
`;
exports.StyledButtonFlat = (0, styled_1.default)(BaseStyledButton) `
  background-color: transparent;
  border-color: transparent;
  color: ${(0, ui_theme_1.fromTheme)('color_button_contrast_text')};
  &:focus,
  &:hover {
    background-color: ${(0, ui_theme_1.fromTheme)('color_button_flat_hover')};
    border-color: ${(0, ui_theme_1.fromTheme)('color_button_flat_hover')};
  }
  &:disabled {
    background-color: transparent;
    border-color: transparent;
    color: ${(0, ui_theme_1.fromTheme)('color_text_button_disabled')};
    cursor: not-allowed;
  }
`;
const withIconStyles = (active, iconAlign) => {
    return !active ? (0, exports.activeButtonStyles)(iconAlign) : '';
};
exports.withIconStyles = withIconStyles;
const activeButtonStyles = (iconAlign) => {
    return `
    padding-left: ${iconAlign === 'left' ? '6px' : '26px'};
    padding-right: ${iconAlign === 'left' ? '26px' : '6px'};
  `;
};
exports.activeButtonStyles = activeButtonStyles;
const activeIconStyles = () => {
    return `
    & span:last-of-type {
      transform: scale(1.5);
    }
  `;
};
exports.activeIconStyles = activeIconStyles;
const workingButtonStyles = () => {
    return `
    padding-left: 37px;
    padding-right: 13px;
  `;
};
exports.workingButtonStyles = workingButtonStyles;
const workingSpinnerStyles = () => {
    return `
    & > span:first-of-type {
      right: 17px;
      transform: scale(1);
    }
  `;
};
exports.workingSpinnerStyles = workingSpinnerStyles;
/**********************
 * buttons with spinner
 **********************/
exports.PrimaryButtonWithSpinner = (0, styled_1.default)(exports.StyledButtonPrimary) `
  padding-left: 25px;
  padding-right: 25px;
  ${(props) => (props.showSpinner ? (0, exports.workingButtonStyles)() : '')};
`;
exports.SecondaryButtonWithSpinner = (0, styled_1.default)(exports.StyledButtonSecondary) `
  padding-left: 25px;
  padding-right: 25px;
  ${(props) => (props.showSpinner ? (0, exports.workingButtonStyles)() : '')};
`;
exports.TertiaryButtonWithSpinner = (0, styled_1.default)(exports.StyledButtonTertiary) `
  padding-left: 25px;
  padding-right: 25px;
  ${(props) => (props.showSpinner ? (0, exports.workingButtonStyles)() : '')};
`;
exports.QuaternaryButtonWithSpinner = (0, styled_1.default)(exports.StyledButtonQuaternary) `
  padding-left: 25px;
  padding-right: 25px;
  ${(props) => (props.showSpinner ? (0, exports.workingButtonStyles)() : '')};
`;
exports.GhostButtonWithSpinner = (0, styled_1.default)(exports.StyledButtonGhost) `
  padding-left: 25px;
  padding-right: 25px;
  ${(props) => (props.showSpinner ? (0, exports.workingButtonStyles)() : '')};
`;
exports.ContrastButtonWithSpinner = (0, styled_1.default)(exports.StyledButtonContrast) `
  padding-left: 25px;
  padding-right: 25px;
  ${(props) => (props.showSpinner ? (0, exports.workingButtonStyles)() : '')};
`;
exports.FlatButtonWithSpinner = (0, styled_1.default)(exports.StyledButtonFlat) `
  padding-left: 25px;
  padding-right: 25px;
  ${(props) => (props.showSpinner ? (0, exports.workingButtonStyles)() : '')};
`;
exports.FloatingPrimaryButtonWithSpinner = (0, styled_1.default)(exports.StyledButtonPrimaryFloating) `
  padding-left: 25px;
  padding-right: 25px;
  ${(props) => (props.showSpinner ? (0, exports.workingButtonStyles)() : '')};
`;
exports.SpinningButtonContent = (0, styled_1.default)('span') `
  align-items: center;
  display: flex;
  justify-content: center;
  & > span:first-of-type {
    display: block;
    position: relative;
    right: 8px;
    transform: scale(0);
    top: -2px;
    transition: 0.3s;
  }

  ${(props) => (props.showSpinner ? (0, exports.workingSpinnerStyles)() : '')};
`;
/*******************
 * buttons with icon
 *******************/
exports.PrimaryButtonWithIcon = (0, styled_1.default)(exports.StyledButtonPrimary) `
  ${(props) => (0, exports.withIconStyles)(props.active, props.iconAlign)};
`;
exports.SecondaryButtonWithIcon = (0, styled_1.default)(exports.StyledButtonSecondary) `
  ${(props) => (0, exports.withIconStyles)(props.active, props.iconAlign)};
`;
exports.TertiaryButtonWithIcon = (0, styled_1.default)(exports.StyledButtonTertiary) `
  ${(props) => (0, exports.withIconStyles)(props.active, props.iconAlign)};
`;
exports.QuaternaryButtonWithIcon = (0, styled_1.default)(exports.StyledButtonQuaternary) `
  ${(props) => (0, exports.withIconStyles)(props.active, props.iconAlign)};
`;
exports.FlatButtonWithIcon = (0, styled_1.default)(exports.StyledButtonFlat) `
  ${(props) => (0, exports.withIconStyles)(props.active, props.iconAlign)};
`;
exports.FloatingPrimaryButtonWithIcon = (0, styled_1.default)(exports.StyledButtonPrimaryFloating) `
  ${(props) => (0, exports.withIconStyles)(props.active, props.iconAlign)};
`;
exports.GhostButtonWithIcon = (0, styled_1.default)(exports.StyledButtonGhost) `
  ${(props) => (0, exports.withIconStyles)(props.active, props.iconAlign)};
`;
exports.ContrastButtonWithIcon = (0, styled_1.default)(exports.StyledButtonContrast) `
  ${(props) => (0, exports.withIconStyles)(props.active, props.iconAlign)};
`;
exports.IconButtonContent = (0, styled_1.default)('span') `
  align-items: center;
  display: flex;
  justify-content: center;
  & > span:first-of-type {
    ${(props) => (props.iconAlign === 'left' ? { order: 2 } : { order: 1 })};
  }

  & > span:last-of-type {
    display: block;
    position: relative;
    transform: scale(0);
    transition: 0.3s;

    ${(props) => props.iconAlign === 'left'
    ? {
        marginRight: '8px',
        order: 1
    }
    : {
        marginLeft: '8px',
        order: 2
    }};
  }
  ${(props) => (props.active ? (0, exports.activeIconStyles)() : '')};
`;
exports.PrimaryButtonLinkWithIcon = (0, styled_1.default)((props) => (react_1.default.createElement(exports.PrimaryButtonWithIcon, Object.assign({ as: "a" }, props)))) ``;
exports.SecondaryButtonLinkWithIcon = (0, styled_1.default)((props) => (react_1.default.createElement(exports.SecondaryButtonWithIcon, Object.assign({ as: "a" }, props)))) ``;
exports.TertiaryButtonLinkWithIcon = (0, styled_1.default)((props) => (react_1.default.createElement(exports.TertiaryButtonWithIcon, Object.assign({ as: "a" }, props)))) ``;
exports.QuaternaryButtonLinkWithIcon = (0, styled_1.default)((props) => (react_1.default.createElement(exports.QuaternaryButtonWithIcon, Object.assign({ as: "a" }, props)))) ``;
exports.FlatButtonLinkWithIcon = (0, styled_1.default)((props) => react_1.default.createElement(exports.FlatButtonWithIcon, Object.assign({ as: "a" }, props))) ``;
exports.FloatingPrimaryLinkWithIcon = (0, styled_1.default)((props) => (react_1.default.createElement(exports.FloatingPrimaryButtonWithIcon, Object.assign({ as: "a" }, props)))) ``;
exports.GhostButtonLinkWithIcon = (0, styled_1.default)((props) => react_1.default.createElement(exports.GhostButtonWithIcon, Object.assign({ as: "a" }, props))) ``;
exports.ContrastButtonLinkWithIcon = (0, styled_1.default)((props) => (react_1.default.createElement(exports.ContrastButtonWithIcon, Object.assign({ as: "a" }, props)))) ``;
/********
 *  links
 ********/
exports.StyledButtonLinkPrimary = (0, styled_1.default)((props) => react_1.default.createElement(exports.StyledButtonPrimary, Object.assign({ as: "a" }, props))) ``;
exports.StyledButtonLinkSecondary = (0, styled_1.default)((props) => (react_1.default.createElement(exports.StyledButtonSecondary, Object.assign({ as: "a" }, props)))) ``;
exports.StyledButtonLinkFlat = (0, styled_1.default)((props) => (react_1.default.createElement(exports.StyledButtonFlat, Object.assign({ as: "a" }, props)))) ``;
exports.PrimaryButtonLinkWithSpinner = (0, styled_1.default)((props) => (react_1.default.createElement(exports.PrimaryButtonWithSpinner, Object.assign({ as: "a" }, props)))) ``;
exports.SecondaryButtonLinkWithSpinner = (0, styled_1.default)((props) => (react_1.default.createElement(exports.SecondaryButtonWithSpinner, Object.assign({ as: "a" }, props)))) ``;
exports.TertiaryButtonLinkWithSpinner = (0, styled_1.default)((props) => (react_1.default.createElement(exports.TertiaryButtonWithSpinner, Object.assign({ as: "a" }, props)))) ``;
exports.QuaternaryButtonLinkWithSpinner = (0, styled_1.default)((props) => (react_1.default.createElement(exports.QuaternaryButtonWithSpinner, Object.assign({ as: "a" }, props)))) ``;
exports.FlatButtonLinkWithSpinner = (0, styled_1.default)((props) => (react_1.default.createElement(exports.FlatButtonWithSpinner, Object.assign({ as: "a" }, props)))) ``;
exports.GhostButtonLinkWithSpinner = (0, styled_1.default)((props) => (react_1.default.createElement(exports.GhostButtonWithSpinner, Object.assign({ as: "a" }, props)))) ``;
exports.ContrastButtonLinkWithSpinner = (0, styled_1.default)((props) => (react_1.default.createElement(exports.ContrastButtonWithSpinner, Object.assign({ as: "a" }, props)))) ``;
exports.FloatingPrimaryButtonLinkWithSpinnner = (0, styled_1.default)((props) => (react_1.default.createElement(exports.FloatingPrimaryButtonWithSpinner, Object.assign({ as: "a" }, props)))) ``;
//# sourceMappingURL=styled-components.js.map